<template>
<!-- Choose Category - LEFT -->
  <div class="product-list" role="tablist">

    <b-card no-body class="mb-1" v-for="category in productData.categories" :key="category.title">

      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-btn block href="#" v-b-toggle.accordion1 variant="info">{{category.title}}</b-btn>
      </b-card-header>

      <b-card-body>
        <ul class="card-text">
          <li v-for="product in category.products" :key="product.name" :class="(selected === product.apiName ? 'active ' : '') + (product['class'] ? product['class'] + ' chip ' : '')" @click="selected = product.apiName">{{product.name}}</li>
        </ul>
      </b-card-body>

    </b-card>
  </div>
</template>

<style lang="scss" scoped>
@import '~scss/colors.scss';

.product-list {
  min-height: 100%;
  background: white;
}
.card {
  position: relative;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: $white;
  background-clip: border-box;
  border: none;
  border-right: 1px solid $frost-0;
  margin-bottom: 0 !important;
}

@media only screen and (max-device-width: 1299px) {
  .card {
    border-left:none;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
  .card {
    border:none;
  }
}

.card-body {
  padding: 0;
  }

.card-header {
  text-transform: lowercase;
  border: none;
}
.card-header a {
  text-align: left;
}

.btn.btn-info {
  color:$black-2;
  padding: 7px 7px 5px 10px;
  text-transform: uppercase;
  font-weight: normal;
  font-size: 13px;
  letter-spacing: 3px;
  line-height: 10px;
  height: auto;
  background-color: $frost-0;
  border-color: $frost-0;
  cursor: pointer;
}

.card-text li {
  list-style: none;
  padding: 8px 0 8px 20px;
  cursor: pointer;
  color: $black-1;
  font-size: 15px;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:last-child{
    border-bottom: 0;
    margin-bottom: 8px;
  }
  &.active {
  font-weight: bold;
  border-right: 5px solid $red;
}
  &.chip::before {
    content: "";
    display: inline-flex;
    align-content: center;
    margin-right: 10px;
    width: 15px;
    height: 15px;
    border: 2px solid #ccc;
    border-radius: 50%;
  }
  &.chip {
    &.black-edge::before {
      background-color: black;
    }
    &.red-edge::before {
      background-color: red;
    }
    &.blue-edge::before {
      background-color: blue;
    }
    &.aqua-edge::before {
      background-color: aqua;
    }
    &.orange-edge::before {
      background-color: orange;
    }
  }
}
</style>

<script>
import productData from "@/data/productData.json";
export default {
  props: ["value", "autoselect", "slug"],
  data() {
    return {selected: null};
  },
  mounted() {
    console.log('mounted:', this.slug, this.selected);
    if (!this.selected) {
      if (this.slug) {
        // Deep link into product
        for (let category of this.productData.categories) {
          for (let product of category.products) {
            if (product.slug === this.slug) {
              this.selected = product.apiName;
            }
          }
        }
        // Replace URL
        // In the future, we should have a link for each product
        this.$router.replace('/business-cards');
      } else if (this.autoselect) {
        // wide viewport, catalog is visible
        // auto-select first item
        this.selected = productData.categories[0].products[0].apiName;
      }
    }
  },
  watch: {
    product(val) {
      this.$emit('input', val)
    }
  },
  computed: {
    productData() {
      return productData;
    },
    product() {
      let result, prev, next;
      for (let category of this.productData.categories) {
        for (let product of category.products) {
          if (product.apiName === this.selected) {
            product.category = category.title;
            result = product;
            continue;
          }
          if (result && !next) next = product;
          if (!result) prev = product;
        }
      }
      if (result && prev) result.prev = () => this.selected = prev.apiName;
      if (result && next) result.next = () => this.selected = next.apiName;
      return result;
    }
  }
};
// $('.collapse').collapse()
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/businesscards/shared/ProductList.vue